import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIList from 'UIComponents/list/UIList';
import FilterOptions from '../../models/FilterOptions';
import FiltersBar from '../common/FiltersBar';
import MoreResultsButton from './MoreResultsButton';
import NoTicketsFoundMessage from '../common/NoTicketsFoundMessage';
import PoweredByFooter from './PoweredByFooter';
import TicketCardItem from './TicketCardItem';
import TicketFiltersPanel from '../filter-panel/TicketFiltersPanel';
import TicketSearchInput from '../common/TicketSearchInput';
import TicketSearchPanel from '../search-panel/TicketSearchPanel';
import TicketsLoadingSpinner from '../common/TicketsLoadingSpinner';
import { fetchFilterOptions } from '../../actions/FilterOptionsActions';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MAX_TICKETS_COUNT = 3;
function TicketSearchCardContent() {
  const dispatch = useDispatch();
  const filterOptions = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseTicketInspector' does not exist on ... Remove this comment to see the full error message
  ({
    zorseTicketInspector
  }) => zorseTicketInspector.filterOptions);
  const tickets = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseTicketInspector' does not exist on ... Remove this comment to see the full error message
  ({
    zorseTicketInspector
  }) => zorseTicketInspector.tickets);
  useEffect(() => {
    if (filterOptions.equals(new FilterOptions())) {
      dispatch(fetchFilterOptions());
    }
  }, [filterOptions, dispatch]);
  const [isFilterPanelOpen, setFilterPanelOpen] = useState(false);
  const [isSearchPanelOpen, setSearchPanelOpen] = useState(false);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isFilterPanelOpen ? /*#__PURE__*/_jsx(TicketFiltersPanel, {
      "data-test-id": "search-card-filters-panel",
      onClose: () => setFilterPanelOpen(false)
    }) : null, isSearchPanelOpen ? /*#__PURE__*/_jsx(TicketSearchPanel, {
      "data-test-id": "search-card-search-panel",
      onClose: () => setSearchPanelOpen(false)
    }) : null, /*#__PURE__*/_jsx("div", {
      className: "m-bottom-4",
      children: /*#__PURE__*/_jsx(TicketSearchInput, {
        "data-test-id": "search-card-search-input"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "m-bottom-2",
      children: /*#__PURE__*/_jsx(FiltersBar, {
        "data-test-id": "search-card-filters-bar",
        onFiltersClick: () => setFilterPanelOpen(true)
      })
    }), /*#__PURE__*/_jsx(UIList, {
      children: tickets.data.tickets.slice(0, MAX_TICKETS_COUNT).map((ticket, i) => /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(TicketCardItem, {
          ticket: ticket
        })
      }, i))
    }), tickets.hasNoResults ? /*#__PURE__*/_jsx(NoTicketsFoundMessage, {
      "data-test-id": "search-card-no-tickets-found-message"
    }) : null, tickets.isLoading ? /*#__PURE__*/_jsx(TicketsLoadingSpinner, {
      "data-test-id": "search-card-loading-spinner"
    }) : null, tickets.data.tickets.size > MAX_TICKETS_COUNT || tickets.data.hasMore ? /*#__PURE__*/_jsx("div", {
      className: "justify-center m-bottom-2",
      children: /*#__PURE__*/_jsx(MoreResultsButton, {
        "data-test-id": "search-card-more-results-button",
        onClick: () => setSearchPanelOpen(true)
      })
    }) : null, /*#__PURE__*/_jsx(PoweredByFooter, {
      "data-test-id": "search-card-powered-by"
    })]
  });
}
function TicketSearchCardTitle() {
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "app.title"
  });
}
export { TicketSearchCardContent, TicketSearchCardTitle };